import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Confirm, Alert } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능: 마이페이지(메뉴들 모음)
 * 세부설명:
*/

export class MyPage extends Component {
    static displayName = MyPage.name;

    constructor(props) {
        super(props);
        this.state = {
            Goods_Count: 0,
            Retail_Count: 0,
            Use_Yn: "N",
            Content: "",
            DeviceToken:[]
        }
            ;
        this.handleLogOut_Click = this.handleLogOut_Click.bind(this);
        this.handelTermsofservice_Click = this.handelTermsofservice_Click.bind(this);
        this.handleAlarm_Change = this.handleAlarm_Change.bind(this);
    }
    async handleLogOut_Click() {
        try {
            
            let Data = await Big3Common.Get("api/Common/Common/Logout");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.Util.RemoveLoginStorage();
                Big3Common.Util.OpenWindowLink("/Account/LoginMgr/Index");
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("handleLogOut_Click: ", e)
        }
        return false;
    }
    //초기화
    componentDidMount() {
        this.CallGoodsRetailCount();
    }
    //내 거래매장, 판매중상품 건수
    CallGoodsRetailCount = async () => {
        try {

            let Data = await Big3Common.Get("api/MyPage/MyInfoMgr/GetGoodsRetailCount");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const GoodsList = DataList.GoodsList;
                const DeviceToken = DataList.DeviceToken;
                const Use_Yn = DataList.Use_Yn;
                if (GoodsList.length > 0) {
                    this.setState({
                        Goods_Count: GoodsList[0].goods_count,
                        Retail_Count: GoodsList[0].retail_count,
                        Use_Yn: Use_Yn,
                        DeviceToken: DeviceToken
                    })
                }
            }   
        }
        catch (e) {
            console.log("handleLogOut_Click: ", e)
        }
        return false;
    }
    //서비스이용약관
    handelTermsofservice_Click(ComponentName) {
        this.props.RenderComponent(ComponentName);
    }
    //알람수신 여부 설정
    handleAlarm_Change = async (event) => {
        try {

            const Use_Yn = event.target.checked === true ? "Y" : "N";
            let Data = await Big3Common.Post('api/MyPage/MyInfoMgr/SetDeviceMgtUseYn', {
                Use_Yn: Use_Yn
            }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Use_Yn: Use_Yn });
            }
            else if (Data.codeName === Big3Common.ResultCode.Warning) {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("CallMyWholeListData", e);
        }

        return false;
    }
    render() {
        return (
            <div className="container_box p_f_margin u_padding ">
                <div className="mypage_info">
                    <div className="shop_name">{Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.OrgName)}</div>
                    <div className="login_name">{Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.UserName)}님 반갑습니다!!</div>
                    <div className="shop_retail">내 거래매장 : {this.state.Retail_Count}매장</div>
                    <div className="shop_retail">판매중인 상품 : {this.state.Goods_Count}개</div>
                    <div className="mypage_icon_menu">
                        <div className="icon_box">
                            <Link to="/Order/OrderMgr/Index">
                                <div className="icon1"></div>
                                <div className="txt">주문</div>
                            </Link>
                        </div>
                        <div className="icon_box" onClick={(e) => this.props.RenderComponent('OrderDtlExcel')}>
                            <div className="icon5"></div>
                            <div className="txt">엑셀주문</div>
                        </div>
                        <div className="icon_box">
                            <Link to="/Goods/GoodsMgr/Index">
                                <div className="icon2"></div>
                                <div className="txt">상품</div>
                            </Link>
                        </div>
                        <div className="icon_box">
                            <Link to="/Retail/MyRetail/Index">
                                <div className="icon3"></div>
                                <div className="txt">거래처</div>
                            </Link>
                        </div>
                        <div className="icon_box" onClick={(e) => this.props.RenderComponent('MyInfoCheck')}>
                            <div className="icon4"></div>
                            <div className="txt">내 정보</div>
                        </div>
                    </div>
                </div>
                <div className="mypage_info">
                    <div className="my_page_menu_title">매장관리</div>
                    <div className="my_page_menu" onClick={(e) => this.props.RenderComponent('StoreInfo')}>매장 정보수정</div>
                    <div className="my_page_menu" onClick={(e) => this.props.RenderComponent('StoreMsg')}>매장 공지사항</div>
                    <div className="my_page_menu" onClick={(e) => this.props.RenderComponent('EmpList')}>직원 관리</div>
                    <div className="my_page_menu" onClick={(e) => this.props.RenderComponent('AccountNumber')}>계좌정보 관리</div>

                </div>
                <div className="mypage_info">
                    <div className="my_page_menu_title">알림설정</div>
                    <div className="my_page_menu2">
                        <div className="my_page_menu">알림수신</div>
                        <div className="wrapper">
                            <input type="checkbox" id="switch" checked={this.state.Use_Yn === "Y" ? true : false} onChange={(e) => { this.handleAlarm_Change(e) }} />
                            <label htmlFor="switch" className="switch_label">
                                <span className="onf_btn"></span>
                            </label>
                        </div>
                    </div>
                    <div className="my_page_menu2">
                        <div className="my_page_menu">Device ID</div>
                        <div className="d_id">
                            {this.state.DeviceToken.length === 0 ? "" : `${this.state.DeviceToken[0].device_id.substring(0, 10)}... (${this.state.DeviceToken[0].reg_dt})`} 
                        </div>
                    </div>
                </div>
                <div className="mypage_info">
                    <div className="my_page_menu_title">정산관리</div>
                    <div className="my_page_menu" onClick={(e) => this.props.RenderComponent('CostSettleList')}>정산하기</div>
                </div>
                <div className="mypage_info">
                    <div className="my_page_menu_title">클로디 정보</div>
                    <div className="my_page_menu" onClick={(e) => this.props.RenderComponent('ServiceCenter')}>고객센터</div>
                    <div className="my_page_menu" onClick={(e) => { this.handelTermsofservice_Click('Privacypolicy'); e.preventDefault(); }}>이용약관</div>
                    <div className="my_page_menu" onClick={(e) => { this.handelTermsofservice_Click('Termsofservice'); e.preventDefault(); }}>개인정보 취급방법</div>
                </div>
                <div className="mypage_info bn">
                    <div className="my_page_menu_title pointer" onClick={() => {
                        Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
                    }} >로그아웃</div>
                </div>
                <Confirm
                    id="ConfirmBox"
                    title="로그아웃 하시겠습니까?"
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleLogOut_Click()
                    }}
                />
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="알림설정안내"
                />
            </div>
        );
    }
}
